import React, { useContext } from 'react';
import { ButtonPrimary, ButtonSecondary, ButtonTertiary, } from '@spotify-internal/encore-web';
import { FrodorModulesContext } from '../../../Context';
import styled from 'styled-components';
export const Link = ({ href, openInNewTab, trackingLabel, trackingCategory, variant = 'a', children, ...rest }) => {
    const { getLinkProps } = useContext(FrodorModulesContext);
    const linkProps = getLinkProps
        ? getLinkProps({
            trackingAttributes: [trackingCategory, trackingLabel, 'click'],
            href,
            openInNewTab,
        })
        : { href, target: openInNewTab ? '_blank' : '_self' };
    switch (variant) {
        case 'buttonPrimary':
            return (React.createElement(ButtonPrimary, { ...linkProps, ...rest }, children));
        case 'buttonSecondary':
            return (React.createElement(ButtonSecondary, { ...linkProps, ...rest }, children));
        default:
        case 'buttonTertiary':
            return (React.createElement(ButtonTertiary, { ...linkProps, ...rest }, children));
        case 'a':
            if (!linkProps.href) {
                return (React.createElement("button", { ...linkProps, ...rest }, children));
            }
            return (React.createElement("a", { ...linkProps, ...rest }, children));
    }
};
export const ButtonPrimaryLink = ({ ...link }) => {
    return (React.createElement(Link, { ...link, variant: "buttonPrimary" }, link.label));
};
export const ButtonSecondaryLink = ({ ...link }) => {
    return (React.createElement(Link, { ...link, variant: "buttonSecondary" }, link.label));
};
export const ButtonTertiaryLink = ({ ...link }) => {
    return (React.createElement(Link, { ...link, variant: "buttonTertiary" }, link.label));
};
const ImageLinkWrapper = styled(Link) `
  > img {
    width: 100%;
  }
`;
export const ImageLink = ({ ...imageLink }) => {
    return (React.createElement(ImageLinkWrapper, { ...imageLink.link },
        React.createElement("img", { src: imageLink.image.file.url, alt: imageLink.altText })));
};
